import { Component } from 'react';
import PropTypes from 'prop-types';
import { CoreNumericInputComponent, staticHypotheekbondUrl, hstatic } from '../../../index';
import ThemeComponent from './ThemeComponent';

class CurrencyInputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
  }

  onChangeHandler(e) {
    this.setState({ value: e.target.value });

    this.props.onChangeHandler(e);
  }

  onClickHandler(e) {
    this.setState({ value: e.target.value });

    this.props.onClickHandler(e);
  }

  onBlurHandler(e) {
    this.props.onBlurHandler(e);
  }

  onFocusHandler(e) {
    this.props.onFocusHandler(e);
  }

  render() {
    const {
      name,
      id,
      label,
      className,
      errors,
      readOnly,
      autoFocus,
      disabled,
    } = this.props;

    let inputClassNames = 'form-control';
    if (this.state.value !== null) {
      inputClassNames += ' has-content';
    }

    let classNames = 'input-field';
    if (className) {
      classNames += ` ${className}`;
    }

    return (
      <ThemeComponent
        label={label}
        className={classNames}
        errors={errors}
        id={id}
        prefixIcon={hstatic(`${staticHypotheekbondUrl()}images/icon/euro.svg`)}
      >
        <CoreNumericInputComponent
          autoFocus={autoFocus}
          readOnly={readOnly}
          name={name}
          id={id}
          onFocusHandler={this.onFocusHandler}
          onClickHandler={this.onClickHandler}
          onChangeHandler={this.onChangeHandler}
          onBlurHandler={this.onBlurHandler}
          value={this.state.value}
          className={inputClassNames}
          decimals={2}
          disabled={disabled}
        />
        { this.props.children }
      </ThemeComponent>
    );
  }
}

CurrencyInputComponent.propTypes = {
  autoFocus: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onFocusHandler: PropTypes.func,
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  children: PropTypes.node,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

CurrencyInputComponent.defaultProps = {
  autoFocus: false,
  className: null,
  name: null,
  readOnly: false,
  value: null,
  id: null,
  disabled: false,
  children: null,
  onChangeHandler: () => {},
  onBlurHandler: () => {},
  onClickHandler: () => {},
  onFocusHandler: () => {},
  errors: null,
};

export default CurrencyInputComponent;
